"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
var react_1 = __importStar(require("react"));
var type_guard_1 = require("@webnuts/type-guard");
var useDebounce_1 = __importDefault(require("react-use/lib/useDebounce"));
var useDebounce = function (args) {
    var onChange = args.onChange;
    // ensure that the number non-negative
    type_guard_1.assert(type_guard_1.integer({ minimum: 0 }), args.debounceTimeout);
    // The inner input is controlled, maintain the value from here.
    var _a = __read(react_1.useState(args.value), 2), value = _a[0], setValue = _a[1];
    // The debounced value state, updated whenever the debounce is flushed or called.
    var _b = __read(react_1.useState(args.value), 2), setDebouncedValue = _b[1];
    // Keep the last persisted DOM event as a ref.
    var eventRef = react_1.default.useRef(undefined);
    // Set the debouncedValue state after the timeout, whenever the value changes.
    useDebounce_1.default(function () { return setDebouncedValue(value); }, args.debounceTimeout, [value]);
    // Whenever the debounced value changes, call the onChange from args.
    var triggerEvent = react_1.default.useCallback(function () {
        if (eventRef.current != null) {
            onChange(eventRef.current);
            eventRef.current = undefined;
        }
    }, [eventRef, onChange]);
    react_1.default.useEffect(triggerEvent, [triggerEvent]);
    // If the hook is about to get unmounted, make sure to flush.
    react_1.default.useEffect(function () { return function () { return triggerEvent(); }; }, [eventRef, onChange, triggerEvent]);
    // On change, debounce the change event and store the last change in a ref.
    var innerOnChange = react_1.default.useCallback(function (event) {
        event.persist();
        eventRef.current = event;
        // Expected cast below, since the value field in the DOM is always a string.
        setValue(event.currentTarget.value);
    }, [setValue]);
    return { value: value, onChange: innerOnChange };
};
exports.useDebounce = useDebounce;
